// import content from './content';
import { useState } from 'react';
import Button from '@CS/components/Button';
// import { useTranslation } from '@CS/hooks';
import { Text, Title } from './PopUpErrorAddMember.styles';
import type { CampaignState } from '@/redux/campaign/types';
import { type PopupProps, Popup } from '@CS/components/Popups';

type PopUpErrorAddMemberProps = PopupProps & {
  campaign: CampaignState;
};

export const PopUpErrorAddMember = ({ campaign, ...props }: PopUpErrorAddMemberProps) => {
  // const { title, text, button } = useTranslation(content);
  const [closed, setClosed] = useState(false);
  const onClick = () => setClosed(true);

  return (
    <Popup close={closed} {...props}>
      <Title>{campaign.translations.oops_title}</Title>
      <Text>{campaign.translations.oops_description}</Text>
      <Button onClick={onClick} text={campaign.translations.oops_cta} />
    </Popup>
  );
};
